import * as yup from "yup";
import { getRole, getstatus } from "./UsersServices";
import { emailRegex, floatingRegex, nameRegex, phoneRegex, wordToWordSpaceRegex } from "../../components/common/Helpers/Validations";
export const formFields: any = [
    {
        label: "First Name",
        type: 'text',
        name: 'f_name',
        placeholder: 'Enter First Name'
    },
    {
        label: "Last Name",
        type: 'text',
        name: 'l_name',
        placeholder: 'Enter Last Name'
    },
    {
        label: "Email",
        type: 'text',
        name: 'email',
        placeholder: 'Enter Email'
    },
    {
        label: "Password",
        type: 'password',
        name: 'password',
        placeholder: 'Enter Password'
    },
    {
        label: "Mobile Number",
        type: 'text',
        name: 'mobile_number',
        placeholder: 'Enter Mobile Number'
    },
    {
        label: "Address",
        type: 'text',
        name: 'address',
        placeholder: 'Enter Address'
    },
    {
        label: "Status",
        type: 'dropdown',
        name: 'status',
        placeholder: 'Enter Status',
        options: getstatus
    },

    {
        label: "Role",
        type: 'dropdown',
        name: 'role_id',
        placeholder: 'Enter Role',
        options: getRole
    },
]

export const validationSchema = yup.object({
    f_name: yup.string().ensure().required("First Name is required!").matches(nameRegex,{message:"Please enter only Alpha Letters!"}).matches(wordToWordSpaceRegex,{message:"Please do not include leading spaces!"}).min(3, 'To short!'),
    l_name: yup.string().ensure().required(" Last Name is required!").matches(nameRegex,{message:"Please enter only Alpha Letters!"}).matches(wordToWordSpaceRegex,{message:"Please do not include leading spaces!"}).min(3, 'To short!'),
    email: yup.string().ensure().required("Email is required!").matches(emailRegex,{message:'Enter Valid Email!',}).min(3, 'To short!'),
    password: yup.string().ensure().required(" Password is required!").min(3, 'To short!'),
    mobile_number: yup.string().ensure().required(" Mobile Number is required!").min(10, 'Invalid Mobile Number').max(10, 'Invalid Mobile Number').matches(phoneRegex,{message:'Enter Valid Phone Number',}),
    address: yup.string().ensure().required("Address is required!").min(3, 'To short!'),
    status: yup.object().required("Status is required!"),
    role_id: yup.object().required("Role is required!"),
});